export default {
    data() {
        return {
            loadTable: true,
        }
    },
    created() {
        this.fetchData()
    },
}
